import React, { FC } from 'react';
import classNames from 'classnames/bind';

import type { AccumulateType } from './types';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const AccumulatorContentWrapper: FC<AccumulateType> = ({
  isInline,
  children,
  withMarginRight,
}) => <div className={cn('wrap', { inline: isInline, withMarginRight })}>{children}</div>;
